import { UserAccountType } from 'entities/User';

export const getColorTagByAccountType = (accountType: UserAccountType): string => {
  if (accountType === UserAccountType.BUSINESS) {
    return 'processing';
  }

  return 'default';
};
